module.exports = __webpack_public_path__ + "img/appstore.2b5ec303.svg";